import * as swcHelpers from '@swc/helpers';
import { DataLayer, calcPrice } from '@grandvisionhq/analytics';
import { Mappers } from '@grandvisionhq/carts-v2';
import { monetate } from '@grandvisionhq/svc-monetate';
import { optionalKey } from '@grandvisionhq/utils';

var CheckoutSteps;
(function(CheckoutSteps) {
    CheckoutSteps["Login"] = 'login';
    CheckoutSteps["Shipping"] = 'shipping';
    CheckoutSteps["Overview"] = 'overview';
    CheckoutSteps["Payment"] = 'payment';
})(CheckoutSteps || (CheckoutSteps = {}));
const checkoutSteps = {
    [CheckoutSteps.Login]: 1,
    [CheckoutSteps.Shipping]: 2,
    [CheckoutSteps.Overview]: 3,
    [CheckoutSteps.Payment]: 4
};
const pushCheckoutEventToDataLayer = (cart, currentStep, currency)=>{
    DataLayer.pushEvent({
        event: 'gvCheckout',
        atfEcommerce: {
            ecommerce: {
                currencyCode: currency,
                cart: {
                    id: cart.id
                },
                checkout: {
                    actionField: {
                        step: checkoutSteps[currentStep]
                    },
                    products: cart.lineItems.map((lineItem)=>Mappers.mapClientModelToProductObject(lineItem)
                    )
                }
            }
        }
    });
};
const pushExpressCheckoutEventToDataLayer = (cart, currency)=>{
    DataLayer.pushEvent({
        event: 'gvCheckout',
        atfEcommerce: {
            ecommerce: {
                currencyCode: currency,
                cart: {
                    id: cart.id
                },
                type: 'express checkout',
                checkout: {
                    actionField: {
                        step: 2
                    },
                    products: cart.lineItems.map((lineItem)=>Mappers.mapClientModelToProductObject(lineItem)
                    )
                }
            }
        }
    });
};
const pushPurchaseEventToDataLayer = (order, currency, cartId)=>{
    const { rawLineItems , orderNumber , discountedAmount , totalPrice , shippingMethodPrice , taxAmount ,  } = order;
    const discountTotal = discountedAmount;
    const originalTotal = [
        ...rawLineItems
    ].reduce((total, currentValue)=>// We are explicitly adding quantity in order line item model hence quantityCount will always present
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (total += currentValue.price.total.subtotal * currentValue.quantity)
    , 0);
    const discountCodes = order.discountCodes ? order.discountCodes.map((discountCode)=>discountCode.code
    ).join() : '';
    DataLayer.pushEcommerceEvent({
        event: 'gvPurchase',
        atfEcommerce: {
            ecommerce: {
                currencyCode: currency,
                cart: {
                    id: cartId !== null && cartId !== void 0 ? cartId : ''
                },
                purchase: {
                    actionField: swcHelpers.objectSpread({
                        id: orderNumber,
                        revenue: calcPrice(totalPrice),
                        tax: taxAmount && calcPrice(taxAmount),
                        shipping: calcPrice(shippingMethodPrice),
                        revenue_includes_tax: 'true',
                        original_revenue: calcPrice(originalTotal),
                        discount_revenue: calcPrice(discountTotal)
                    }, optionalKey('coupon', discountCodes)),
                    products: DataLayer.DataLayerUtils.mapOrderLineItemToDataLayerProductObjects(rawLineItems)
                }
            }
        }
    });
};
function mapOrderLineItemsToPurchaseRows(order) {
    var ref;
    const regularLineItems = order.lineItems.map((lineItem)=>{
        var _sku;
        return {
            purchaseId: order.id,
            productId: lineItem.productId,
            sku: (_sku = lineItem.variant.sku) !== null && _sku !== void 0 ? _sku : '',
            quantity: lineItem.quantity,
            unitPrice: `${Math.floor(lineItem.totalPrice.centAmount / 100)}`,
            currency: lineItem.totalPrice.currencyCode
        };
    });
    const customLineItems = (ref = order.prescriptionGlassesLineItems) === null || ref === void 0 ? void 0 : ref.map((lineItem)=>{
        var _sku;
        return {
            purchaseId: order.id,
            productId: lineItem.bundleMainLineItem.productId,
            sku: (_sku = lineItem.bundleMainLineItem.variant.sku) !== null && _sku !== void 0 ? _sku : '',
            quantity: lineItem.quantity,
            unitPrice: `${Math.floor(lineItem.totalPrice.centAmount / 100)}`,
            currency: lineItem.totalPrice.currencyCode
        };
    });
    return regularLineItems.concat(customLineItems || []);
}
function trackOrderCompletionEvents(order, isMonetateProductDataEnabled) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    let productType = (ref1 = (ref = order.lineItems[0]) === null || ref === void 0 ? void 0 : ref.productType.obj) === null || ref1 === void 0 ? void 0 : ref1.key;
    const batchEvents = [
        [
            `PaymentType__${(ref3 = (ref2 = order.paymentInfo) === null || ref2 === void 0 ? void 0 : ref2.payments[0]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.obj) === null || ref4 === void 0 ? void 0 : ref4.paymentMethodInfo.method}`
        ],
        [
            `ShippingMode__${(ref5 = order.shippingInfo) === null || ref5 === void 0 ? void 0 : ref5.shippingMethodName}`
        ], 
    ];
    const mainItem = (ref6 = order.prescriptionGlassesLineItems) === null || ref6 === void 0 ? void 0 : ref6[0];
    if (mainItem) {
        productType = mainItem.bundleMainLineItem.productType;
        batchEvents.push([
            `Product__${productType}`
        ]);
        for (const item of mainItem.bundleChildLineItems){
            if (item.productType === 'LensTypes') {
                if (item.variant.sku) {
                    batchEvents.push([
                        `Lenses__${item.variant.sku}`
                    ]);
                }
            }
        }
    } else {
        batchEvents.push([
            `Product__${productType}`
        ]);
    }
    monetate().trackBatchEvents(...batchEvents);
    monetate().trackPurchases(isMonetateProductDataEnabled ? mapOrderLineItemsToPurchaseRows(order) : []);
}

export { CheckoutSteps, pushCheckoutEventToDataLayer, pushExpressCheckoutEventToDataLayer, pushPurchaseEventToDataLayer, trackOrderCompletionEvents };
//# sourceMappingURL=data-layer.js.map
